(ns practitest.frontend.dashboards-settings.events
  (:require [ajax.core :as ajax]
            [re-frame.core :as re-frame]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.components2.dashboard.tab-events :as tab-events]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]))

(def db-key :dashboards-settings)

(defn- update-tabs [db f]
  (update-in db [db-key :tabs] (comp vec f)))

(defn- replace-tab [db tab]
  (update-tabs db (fn [tabs] (map #(if (= (:id %) (:id tab)) tab %) tabs))))

(defn- set-tab-items [db tab-id items]
  (update-tabs db (fn [tabs] (map #(if (= (:id %) tab-id) (assoc % :items (vec items)) %) tabs))))

(re-frame/reg-event-fx
 ::fetch
 (fn [{:keys [db]} _]
   {:db         (assoc-in db [db-key :loading?] true)
    :http-xhrio {:method          :get
                 :uri             (broutes/get-url "dashboards#index"
                                                   {:p_id (subs/get-current-project-id db)}
                                                   {:format "json"})
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [::fetched]
                 :on-failure      [::request-failed]}}))

(re-frame/reg-event-db
 ::fetched
 (fn [db [_ {:keys [tabs tab_filter_fields permissions new_tab]}]]
   (update db db-key merge {:tabs              (vec tabs)
                            :tab-filter-fields tab_filter_fields
                            :permissions       permissions
                            :new-tab           new_tab
                            :loading?          false})))

(re-frame/reg-event-db
 ::reset
 (fn [db _]
   (dissoc db db-key)))

(re-frame/reg-event-fx
 ::request-failed
 (fn [{:keys [db]} [_ response]]
   {:db       (assoc-in db [db-key :loading?] false)
    :dispatch [::notifications/error2 (tab-events/error-message response)]}))

(re-frame/reg-event-db
 ::toggle-show-archived
 (fn [db _]
   (update-in db [db-key :show-archived?] not)))

;; ---- Tab action results (requests are in components2.dashboard.tab-events) ----

(re-frame/reg-event-fx
 ::tab-cloned
 (fn [{:keys [db]} [_ {:keys [source_id tab]}]]
   {:db       (update-tabs db (fn [tabs]
                                (mapcat #(if (= (:id %) source_id) [% tab] [%]) tabs)))
    :dispatch [::notifications/success2 (get-translation "dashboards.notify.cloned" "The dashboard tab was cloned.")]}))

(re-frame/reg-event-fx
 ::tab-updated
 (fn [{:keys [db]} [_ message {:keys [tab]}]]
   (cond-> {:db (replace-tab db tab)}
     message (assoc :dispatch [::notifications/success2 message]))))

(re-frame/reg-event-fx
 ::tab-deleted
 (fn [{:keys [db]} [_ {:keys [id]}]]
   {:db       (update-tabs db (fn [tabs] (remove #(= (:id %) id) tabs)))
    :dispatch [::notifications/success2 (get-translation "dashboards.notify.deleted" "The dashboard tab was deleted.")]}))

(re-frame/reg-event-fx
 ::tab-saved
 (fn [{:keys [db]} [_ {:keys [tab]}]]
   {:db       (-> db
                  (replace-tab tab)
                  (update db-key dissoc :edit-modal))
    :dispatch [::notifications/success2 (get-translation "dashboards.notify.updated" "The dashboard tab was updated.")]}))

;; New tabs are added last (acts_as_list), so append; archived tabs are ordered last by the view sub anyway
(re-frame/reg-event-fx
 ::tab-created
 (fn [{:keys [db]} [_ {:keys [tab]}]]
   {:db       (-> db
                  (update-tabs #(concat % [tab]))
                  (update db-key dissoc :edit-modal))
    :dispatch [::notifications/success2 (get-translation "dashboards.notify.created" "The dashboard tab was created.")]}))

(re-frame/reg-event-fx
 ::delete-item
 (fn [{:keys [db]} [_ tab-id item-id]]
   {:http-xhrio {:method          :delete
                 :uri             (broutes/get-url "dashboard_items#destroy"
                                                   {:p_id (subs/get-current-project-id db) :id item-id}
                                                   {:format "json"})
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      [::item-deleted tab-id]
                 :on-failure      [::request-failed]}}))

(re-frame/reg-event-fx
 ::item-deleted
 (fn [{:keys [db]} [_ tab-id {:keys [id]}]]
   {:db       (update-tabs db (fn [tabs]
                                (map #(if (= (:id %) tab-id)
                                        (-> %
                                            (update :items (fn [items] (vec (remove (fn [i] (= (:id i) id)) items))))
                                            (assoc :can_add_item (:editable %)))
                                        %)
                                     tabs)))
    :dispatch [::notifications/success2 (get-translation "dashboards.notify.item-deleted" "Dashboard item was deleted.")]}))

(re-frame/reg-event-fx
 ::sort-items
 (fn [{:keys [db]} [_ tab-id sorted-items]]
   (let [previous (some #(when (= (:id %) tab-id) (:items %)) (get-in db [db-key :tabs]))]
     {:db         (-> db
                      (set-tab-items tab-id sorted-items)
                      (assoc-in [db-key :sorting?] true))
      :http-xhrio {:method          :post
                   :uri             (broutes/get-url "dashboard_items#sort"
                                                     {:p_id (subs/get-current-project-id db)}
                                                     {:format "json"})
                   :params          {:dashboard_id tab-id :item_ids (map :id sorted-items)}
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::items-sorted]
                   :on-failure      [::sort-items-failed tab-id previous]}})))

(re-frame/reg-event-db
 ::items-sorted
 (fn [db _]
   (assoc-in db [db-key :sorting?] false)))

(re-frame/reg-event-fx
 ::sort-items-failed
 (fn [{:keys [db]} [_ tab-id previous response]]
   {:db       (-> db
                  (set-tab-items tab-id previous)
                  (assoc-in [db-key :sorting?] false))
    :dispatch [::request-failed response]}))
